import React from 'react';
import { Formik, Form } from 'formik';
import { isEmpty } from 'lodash';
import client from 'utils/client';

import { useAuth } from 'contexts/AuthContext';
import { useToast } from 'components/Toast/useToast';

import { PasswordInput } from 'components/FormElements/TextInput';
import './login.css';

const initialValues = { currentPassword: '', newPassword: '', confirmPassword: '' };
function validation(values) {
  const errors = {};

  if (values.currentPassword === values.newPassword) {
    errors.newPassword = 'Enter a different password';
  }
  if (values.newPassword !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords must match';
  }
  return errors;
}

const ChangePassword = ({ logout }) => {
  const { userDetails, isMerchant } = useAuth();
  const { onOpen } = useToast();

  function handleSubmit(values) {
    const request = isMerchant
      ? client.post('/authentication/change-password', {
        old_password: values.currentPassword,
        new_password: values.newPassword,
      })
      : client.post('/staff/reset/password', {
        email: userDetails.email,
        oldPassword: values.currentPassword,
        newPassword: values.newPassword,
      });

    return request
      .then(() => {
        onOpen({ type: 'success', message: 'Password changed Successfully' });
        logout();
      })
      .catch((error) => {
        onOpen({ type: 'error', message: error?.message });
      });
  }

  return (
    <div className='auth-shell'>
      <div className='auth-card'>
        <div className='auth-brand'>
          <span className='auth-brand-mark' aria-hidden='true'>GTI</span>
          <span className='auth-brand-word'>Microfinance</span>
        </div>
        <h1 className='auth-title'>Change password</h1>
        <p className='auth-subtitle'>You must set a new password before continuing.</p>

        <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validation}>
          {({ isSubmitting, errors }) => (
            <Form className='auth-form'>
              <PasswordInput className='form-field' name='currentPassword' label='Current password' placeholder='Current password' required />
              <PasswordInput className='form-field' name='newPassword' label='New password' placeholder='New password' required />
              <PasswordInput className='form-field' name='confirmPassword' label='Confirm password' placeholder='Confirm password' required />
              <button className='btn-primary auth-submit' disabled={isSubmitting || !isEmpty(errors)} type='submit'>
                {isSubmitting ? 'Submitting…' : 'Update password'}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePassword;
